module.exports = __webpack_public_path__ + "static/media/df (6).bc90c04f.jpg";